module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nin vec2 fs_UV;\r\nout vec4 out_Col;\r\n\r\nuniform sampler2D u_frame;\r\nuniform sampler2D u_frame2;\r\nuniform float u_Time;\r\nuniform float u_Radius;\r\nuniform float u_Width;\r\nuniform float u_Height;\r\n\r\n// Interpolation between color and greyscale over time on left half of screen\r\nvoid main() {\r\n\r\n    out_Col = vec4(u_Radius * texture(u_frame2, fs_UV).rgb + texture(u_frame, fs_UV).rgb, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/blendtextures-frag.glsl
// module id = 43
// module chunks = 0